import { RouteConfig } from 'vue-router';
const BASE_PATH = 'views/government/systemSettings';
const systemSettings: Array<RouteConfig> = [
    {
        path: 'systemSettings',
        name: 'systemSettings',
        meta: {
            menuMatch: 'systemSettings',
            index: '4',
        },
        component: () => import(`@/${BASE_PATH}/systemSettings.vue`),
    },
];
export default systemSettings;